var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Children, cloneElement, isValidElement } from 'react';
import Button from './button';
import { useModal } from './modal-context';
import { footerStyle } from './styles';
function Footer(_a) {
    var { children } = _a, restProps = __rest(_a, ["children"]);
    const { alignCenter, autoFocusRef } = useModal();
    // Add a reference to the button with autoFocus (if present), so that it can be focused on open
    function renderChildren() {
        return Children.map(children, (child) => {
            if (isValidElement(child)) {
                return child.type === Button && child.props.autoFocus !== undefined
                    ? cloneElement(child, Object.assign(Object.assign({}, child.props), { ref: autoFocusRef }))
                    : child;
            }
            return child;
        });
    }
    return (_jsx("footer", Object.assign({}, restProps, { css: footerStyle({ alignCenter }) }, { children: renderChildren() })));
}
export default Footer;
